import { gql } from '@apollo/client';

const CREATE_RMA_TICKET = gql`
  mutation createRmaTicket($input: CreateRmaTicketInput!) {
    createRmaTicket(input: $input) {
      isSuccess
      message
      rmaTicket {
        id
      }
    }
  }
`;

export default CREATE_RMA_TICKET;
